import { jsx as i } from "react/jsx-runtime";
import { Typography as y } from "@mui/material";
const a = (l) => (e) => /* @__PURE__ */ i(y, { ...e, variant: l }), d = {
  Body1: a("body1"),
  Body2: a("body2"),
  Body1SemiBold: a("body1SemiBold"),
  Body2SemiBold: a("body2SemiBold"),
  Button: a("button"),
  Caption: a("caption"),
  H1: a("h1"),
  H2: a("h2"),
  H3: a("h3"),
  H4: a("h4"),
  H5: a("h5"),
  H6: a("h6"),
  Overline: a("overline"),
  Subtitle1: a("subtitle1"),
  Subtitle2: a("subtitle2"),
  "Display2XL.Bold": a("Display2XL.Bold"),
  "Display2XL.SemiBold": a("Display2XL.SemiBold"),
  "Display2XL.Medium": a("Display2XL.Medium"),
  "Display2XL.Regular": a("Display2XL.Regular"),
  "DisplayXL.Bold": a("DisplayXL.Bold"),
  "DisplayXL.SemiBold": a("DisplayXL.SemiBold"),
  "DisplayXL.Medium": a("DisplayXL.Medium"),
  "DisplayXL.Regular": a("DisplayXL.Regular"),
  "DisplayLg.Bold": a("DisplayLg.Bold"),
  "DisplayLg.SemiBold": a("DisplayLg.SemiBold"),
  "DisplayLg.Medium": a("DisplayLg.Medium"),
  "DisplayLg.Regular": a("DisplayLg.Regular"),
  "DisplayMd.Bold": a("DisplayMd.Bold"),
  "DisplayMd.SemiBold": a("DisplayMd.SemiBold"),
  "DisplayMd.Medium": a("DisplayMd.Medium"),
  "DisplayMd.Regular": a("DisplayMd.Regular"),
  "DisplaySm.Bold": a("DisplaySm.Bold"),
  "DisplaySm.SemiBold": a("DisplaySm.SemiBold"),
  "DisplaySm.Medium": a("DisplaySm.Medium"),
  "DisplaySm.Regular": a("DisplaySm.Regular"),
  "DisplayXs.Bold": a("DisplayXs.Bold"),
  "DisplayXs.SemiBold": a("DisplayXs.SemiBold"),
  "DisplayXs.Medium": a("DisplayXs.Medium"),
  "DisplayXs.Regular": a("DisplayXs.Regular"),
  "TextMd.Bold": a("TextMd.Bold"),
  "TextMd.SemiBold": a("TextMd.SemiBold"),
  "TextMd.Medium": a("TextMd.Medium"),
  "TextMd.Regular": a("TextMd.Regular"),
  "TextSm.Bold": a("TextSm.Bold"),
  "TextSm.SemiBold": a("TextSm.SemiBold"),
  "TextSm.Medium": a("TextSm.Medium"),
  "TextSm.Regular": a("TextSm.Regular"),
  "TextXs.Bold": a("TextXs.Bold"),
  "TextXs.SemiBold": a("TextXs.SemiBold"),
  "TextXs.Medium": a("TextXs.Medium"),
  "TextXs.Regular": a("TextXs.Regular"),
  Display2XL: {
    Bold: a("Display2XL.Bold"),
    SemiBold: a("Display2XL.SemiBold"),
    Medium: a("Display2XL.Medium"),
    Regular: a("Display2XL.Regular")
  },
  DisplayXL: {
    Bold: a("DisplayXL.Bold"),
    SemiBold: a("DisplayXL.SemiBold"),
    Medium: a("DisplayXL.Medium"),
    Regular: a("DisplayXL.Regular")
  },
  DisplayLg: {
    Bold: a("DisplayLg.Bold"),
    SemiBold: a("DisplayLg.SemiBold"),
    Medium: a("DisplayLg.Medium"),
    Regular: a("DisplayLg.Regular")
  },
  DisplayMd: {
    Bold: a("DisplayMd.Bold"),
    SemiBold: a("DisplayMd.SemiBold"),
    Medium: a("DisplayMd.Medium"),
    Regular: a("DisplayMd.Regular")
  },
  DisplaySm: {
    Bold: a("DisplaySm.Bold"),
    SemiBold: a("DisplaySm.SemiBold"),
    Medium: a("DisplaySm.Medium"),
    Regular: a("DisplaySm.Regular")
  },
  DisplayXs: {
    Bold: a("DisplayXs.Bold"),
    SemiBold: a("DisplayXs.SemiBold"),
    Medium: a("DisplayXs.Medium"),
    Regular: a("DisplayXs.Regular")
  },
  TextMd: {
    Bold: a("TextMd.Bold"),
    SemiBold: a("TextMd.SemiBold"),
    Medium: a("TextMd.Medium"),
    Regular: a("TextMd.Regular")
  },
  TextSm: {
    Bold: a("TextSm.Bold"),
    SemiBold: a("TextSm.SemiBold"),
    Medium: a("TextSm.Medium"),
    Regular: a("TextSm.Regular")
  },
  TextXs: {
    Bold: a("TextXs.Bold"),
    SemiBold: a("TextXs.SemiBold"),
    Medium: a("TextXs.Medium"),
    Regular: a("TextXs.Regular")
  },
  Brand2XL: {
    Bold: a("Brand2XL.Bold"),
    SemiBold: a("Brand2XL.SemiBold"),
    Medium: a("Brand2XL.Medium"),
    Regular: a("Brand2XL.Regular")
  },
  BrandXL: {
    Bold: a("BrandXL.Bold"),
    SemiBold: a("BrandXL.SemiBold"),
    Medium: a("BrandXL.Medium"),
    Regular: a("BrandXL.Regular")
  },
  BrandLg: {
    Bold: a("BrandLg.Bold"),
    SemiBold: a("BrandLg.SemiBold"),
    Medium: a("BrandLg.Medium"),
    Regular: a("BrandLg.Regular")
  },
  BrandMd: {
    Bold: a("BrandMd.Bold"),
    SemiBold: a("BrandMd.SemiBold"),
    Medium: a("BrandMd.Medium"),
    Regular: a("BrandMd.Regular")
  },
  BrandSm: {
    Bold: a("BrandSm.Bold"),
    SemiBold: a("BrandSm.SemiBold"),
    Medium: a("BrandSm.Medium"),
    Regular: a("BrandSm.Regular")
  },
  BrandXs: {
    Bold: a("BrandXs.Bold"),
    SemiBold: a("BrandXs.SemiBold"),
    Medium: a("BrandXs.Medium"),
    Regular: a("BrandXs.Regular")
  }
};
d.Body1.displayName = "Typography.Body1";
d.Body2.displayName = "Typography.Body2";
d.Body1SemiBold.displayName = "Typography.Body1SemiBold";
d.Body2SemiBold.displayName = "Typography.Body2SemiBold";
d.Button.displayName = "Typography.Button";
d.Caption.displayName = "Typography.Caption";
d.H1.displayName = "Typography.H1";
d.H2.displayName = "Typography.H2";
d.H3.displayName = "Typography.H3";
d.H4.displayName = "Typography.H4";
d.H5.displayName = "Typography.H5";
d.H6.displayName = "Typography.H6";
d.Overline.displayName = "Typography.Overline";
d.Subtitle1.displayName = "Typography.Subtitle1";
d.Subtitle2.displayName = "Typography.Subtitle2";
d.Display2XL.Bold.displayName = "Typography.Display2XL.Bold";
d.Display2XL.SemiBold.displayName = "Typography.Display2XL.SemiBold";
d.Display2XL.Medium.displayName = "Typography.Display2XL.Medium";
d.Display2XL.Regular.displayName = "Typography.Display2XL.Regular";
d.DisplayXL.Bold.displayName = "Typography.DisplayXL.Bold";
d.DisplayXL.SemiBold.displayName = "Typography.DisplayXL.SemiBold";
d.DisplayXL.Medium.displayName = "Typography.DisplayXL.Medium";
d.DisplayXL.Regular.displayName = "Typography.DisplayXL.Regular";
d.DisplayLg.Bold.displayName = "Typography.DisplayLg.Bold";
d.DisplayLg.SemiBold.displayName = "Typography.DisplayLg.SemiBold";
d.DisplayLg.Medium.displayName = "Typography.DisplayLg.Medium";
d.DisplayLg.Regular.displayName = "Typography.DisplayLg.Regular";
d.DisplayMd.Bold.displayName = "Typography.DisplayMd.Bold";
d.DisplayMd.SemiBold.displayName = "Typography.DisplayMd.SemiBold";
d.DisplayMd.Medium.displayName = "Typography.DisplayMd.Medium";
d.DisplayMd.Regular.displayName = "Typography.DisplayMd.Regular";
d.DisplaySm.Bold.displayName = "Typography.DisplaySm.Bold";
d.DisplaySm.SemiBold.displayName = "Typography.DisplaySm.SemiBold";
d.DisplaySm.Medium.displayName = "Typography.DisplaySm.Medium";
d.DisplaySm.Regular.displayName = "Typography.DisplaySm.Regular";
d.DisplayXs.Bold.displayName = "Typography.DisplayXs.Bold";
d.DisplayXs.SemiBold.displayName = "Typography.DisplayXs.SemiBold";
d.DisplayXs.Medium.displayName = "Typography.DisplayXs.Medium";
d.DisplayXs.Regular.displayName = "Typography.DisplayXs.Regular";
d.TextMd.Bold.displayName = "Typography.TextMd.Bold";
d.TextMd.SemiBold.displayName = "Typography.TextMd.SemiBold";
d.TextMd.Medium.displayName = "Typography.TextMd.Medium";
d.TextMd.Regular.displayName = "Typography.TextMd.Regular";
d.TextSm.Bold.displayName = "Typography.TextSm.Bold";
d.TextSm.SemiBold.displayName = "Typography.TextSm.SemiBold";
d.TextSm.Medium.displayName = "Typography.TextSm.Medium";
d.TextSm.Regular.displayName = "Typography.TextSm.Regular";
d.TextXs.Bold.displayName = "Typography.TextXs.Bold";
d.TextXs.SemiBold.displayName = "Typography.TextXs.SemiBold";
d.TextXs.Medium.displayName = "Typography.TextXs.Medium";
d.TextXs.Regular.displayName = "Typography.TextXs.Regular";
d.Brand2XL.Bold.displayName = "Typography.Brand2XL.Bold";
d.Brand2XL.SemiBold.displayName = "Typography.Brand2XL.SemiBold";
d.Brand2XL.Medium.displayName = "Typography.Brand2XL.Medium";
d.Brand2XL.Regular.displayName = "Typography.Brand2XL.Regular";
d.BrandXL.Bold.displayName = "Typography.BrandXL.Bold";
d.BrandXL.SemiBold.displayName = "Typography.BrandXL.SemiBold";
d.BrandXL.Medium.displayName = "Typography.BrandXL.Medium";
d.BrandXL.Regular.displayName = "Typography.BrandXL.Regular";
d.BrandLg.Bold.displayName = "Typography.BrandLg.Bold";
d.BrandLg.SemiBold.displayName = "Typography.BrandLg.SemiBold";
d.BrandLg.Medium.displayName = "Typography.BrandLg.Medium";
d.BrandLg.Regular.displayName = "Typography.BrandLg.Regular";
d.BrandMd.Bold.displayName = "Typography.BrandMd.Bold";
d.BrandMd.SemiBold.displayName = "Typography.BrandMd.SemiBold";
d.BrandMd.Medium.displayName = "Typography.BrandMd.Medium";
d.BrandMd.Regular.displayName = "Typography.BrandMd.Regular";
d.BrandSm.Bold.displayName = "Typography.BrandSm.Bold";
d.BrandSm.SemiBold.displayName = "Typography.BrandSm.SemiBold";
d.BrandSm.Medium.displayName = "Typography.BrandSm.Medium";
d.BrandSm.Regular.displayName = "Typography.BrandSm.Regular";
d.BrandXs.Bold.displayName = "Typography.BrandXs.Bold";
d.BrandXs.SemiBold.displayName = "Typography.BrandXs.SemiBold";
d.BrandXs.Medium.displayName = "Typography.BrandXs.Medium";
d.BrandXs.Regular.displayName = "Typography.BrandXs.Regular";
export {
  d as Typography
};
//# sourceMappingURL=index59.mjs.map
